export default "/images/36547c05b1df5f3df634b9a06a65ea6d.avif";